import { TimelineGroupWebComponent } from './component/TimelineGroupWebComponent';
import { WEB_COMPONENT_TIMELINE_GROUP } from '../../webcomponents.constants';

export { TimelineGroupWebComponent };

window.customElements.define(WEB_COMPONENT_TIMELINE_GROUP, TimelineGroupWebComponent);
